const collator = new Intl.Collator("pt-BR", { numeric: true, sensitivity: "base" })
const prefixosPrioritarios = ["CB", "CL", "CM", "CP", "EH", "MN", "RC", "TE", "TP", "ON", "PLY", "SJQ", "SKN", "CA", "GOL"]
const prioridade = new Map(prefixosPrioritarios.map((prefixo, indice) => [prefixo, indice]))

export function compararEquipamentos(a, b) {
  const codigoA = String(a?.codigo ?? "").trim()
  const codigoB = String(b?.codigo ?? "").trim()
  if (!codigoA || !codigoB) return codigoA ? -1 : codigoB ? 1 : 0
  const prefixoA = codigoA.match(/^\p{L}+/u)?.[0] || ""
  const prefixoB = codigoB.match(/^\p{L}+/u)?.[0] || ""
  const indiceA = prioridade.get(prefixoA.toLocaleUpperCase("pt-BR"))
  const indiceB = prioridade.get(prefixoB.toLocaleUpperCase("pt-BR"))
  const ordemA = indiceA ?? prefixosPrioritarios.length
  const ordemB = indiceB ?? prefixosPrioritarios.length
  return ordemA - ordemB || (indiceA === undefined ? collator.compare(prefixoA, prefixoB) : 0) || collator.compare(codigoA, codigoB)
}

export function ordenarEquipamentos(registros = []) {
  return [...registros].sort(compararEquipamentos)
}

// Apontamentos usam datas ISO (YYYY-MM-DD) do banco e das planilhas analisadas.
// A conversão lê os componentes explicitamente para evitar interpretar DD/MM/YYYY
// como MM/DD/YYYY ou introduzir deslocamentos de fuso horário.
function chaveData(valor) {
  if (valor instanceof Date && !Number.isNaN(valor.getTime())) {
    return valor.getFullYear() * 10000 + (valor.getMonth() + 1) * 100 + valor.getDate()
  }
  const texto = String(valor ?? "").trim()
  const iso = texto.match(/^(\d{4})-(\d{2})-(\d{2})/)
  const br = texto.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
  const partes = iso ? [Number(iso[1]), Number(iso[2]), Number(iso[3])] : br ? [Number(br[3]), Number(br[2]), Number(br[1])] : null
  if (!partes) return null
  const [ano, mes, dia] = partes
  const data = new Date(Date.UTC(ano, mes - 1, dia))
  if (data.getUTCFullYear() !== ano || data.getUTCMonth() !== mes - 1 || data.getUTCDate() !== dia) return null
  return ano * 10000 + mes * 100 + dia
}

export function compararApontamentos(a, b) {
  const dataA = chaveData(a?.fim ?? a?.data ?? a?.data_apontamento ?? a?.dataUltimaLeitura ?? a?.dataUltimaRevisao ?? a?.atual?.data ?? a?.inicio)
  const dataB = chaveData(b?.fim ?? b?.data ?? b?.data_apontamento ?? b?.dataUltimaLeitura ?? b?.dataUltimaRevisao ?? b?.atual?.data ?? b?.inicio)
  if (dataA !== dataB) {
    if (dataA === null) return 1
    if (dataB === null) return -1
    return dataB - dataA
  }
  return compararEquipamentos(a, b)
}

export function ordenarApontamentos(registros = []) {
  return [...registros].sort(compararApontamentos)
}
